import React from 'react';
import PropTypes from 'prop-types';
import { Box, Flex, Heading, Button, Modal, Card, Checkbox, Text } from 'rimble-ui';

const PopUpModal = ({
	checkboxValue2,
	setCheckboxValue2,
	isOpen,
	closeModal,
	transactionURL,
	downloadfunction,
	Message
}) => {
	return (
		<div>
			{!!!Message === true ? ( // For Transaction
				<Modal isOpen={isOpen}>
					<Card style={{ borderRadius: '15px' }} width={'660px'} p={0}>
						<Button.Text
							icononly
							icon={'Close'}
							color={'moon-gray'}
							position={'absolute'}
							top={0}
							right={0}
							mt={3}
							mr={3}
							onClick={closeModal}
							disabled={checkboxValue2}
						/>

						<Box p={4} mb={3}>
							<Heading>Submitted Transaction</Heading>
							<br />
							{transactionURL && (
								<a
									target="_blank"
									rel="noopener noreferrer"
									style={{
										color: '#61dafb',
										marginTop: '10px',
										display: 'block'
									}}
									href={transactionURL}
								>
									Transaction Link on Etherescan.
								</a>
							)}
							<br />

							<Text> Please do not resend the same transaction.</Text>
							<div style={{ marginTop: '20px', marginBottom: '-20px' }}>
								<Checkbox
									label="I do not want to download the receipts - ( Now or never )"
									value={checkboxValue2}
									onChange={(e) => setCheckboxValue2(!checkboxValue2)}
								/>
							</div>
						</Box>

						<Flex px={4} py={3} borderTop={1} borderColor={'#E8E8E8'} justifyContent={'space-between'}>
							<Button onClick={downloadfunction}>Download receipts</Button>

							<Button.Outline onClick={closeModal} disabled={checkboxValue2}>
								Noted
							</Button.Outline>
						</Flex>
					</Card>
				</Modal>
			) : (
				<Modal isOpen={isOpen}>
					<Card style={{ borderRadius: '15px' }} width={'660px'} p={0}>
						<Button.Text
							icononly
							icon={'Close'}
							color={'moon-gray'}
							position={'absolute'}
							top={0}
							right={0}
							mt={3}
							mr={3}
							onClick={closeModal}
						/>

						<Box p={4} mb={3}>
							<Heading> ⚠️ Contract Address Notice ! </Heading>
							<br />
							<br />
							<Text> {Message}</Text>
						</Box>
						<Flex px={4} py={3} borderTop={1} borderColor={'#E8E8E8'} justifyContent={'flex-end;'}>
							<Button.Outline onClick={closeModal}>Noted</Button.Outline>
						</Flex>
					</Card>
				</Modal>
			)}
		</div>
	);
};

PopUpModal.propTypes = {
	closeModal: PropTypes.func.isRequired,
	transactionURL: PropTypes.string,
	Message: PropTypes.string,
	isOpen: PropTypes.bool.isRequired
};

export default PopUpModal;
